export enum RdxContextType {
    TC_PROJECT = 0,
    PROJECT = 1,
    RELEASE = 2,
    PORTFOLIO = 3,
    RDX_TC_PROJECT = 4,
    RDX_PCQ = 5,
    SYSTEM = 6,
    COMPANY = 7
}
